import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/form-title.png'
import _imports_1 from '../assets/login/student_mascot.png'
import _imports_2 from '../assets/login-information-sheetA.png'
import _imports_3 from '../assets/login-information-sheetB.png'
import _imports_4 from '../assets/login-information-sheetC.png'
import _imports_5 from '../assets/form_book.png'
import _imports_6 from '../assets/new-student-guide-qr.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-4cbbb59c")

_pushScopeId("data-v-4cbbb59c")
const _hoisted_1 = { class: "school-ai-print-page" }
const _hoisted_2 = { class: "school-ai-print-sheets" }
const _hoisted_3 = { class: "school-ai-sheet-header" }
const _hoisted_4 = { class: "school-ai-wordmark" }
const _hoisted_5 = {
  key: 0,
  class: "school-ai-wordmark-text"
}
const _hoisted_6 = {
  key: 1,
  src: _imports_0,
  alt: "スクールAI"
}
const _hoisted_7 = /*#__PURE__*/_createVNode("h1", null, [
  /*#__PURE__*/_createTextVNode(" ログイン "),
  /*#__PURE__*/_createVNode("ruby", null, [
    /*#__PURE__*/_createTextVNode(" 情報"),
    /*#__PURE__*/_createVNode("rt", null, "じょうほう")
  ])
], -1)
const _hoisted_8 = { class: "school-ai-step school-ai-step-one" }
const _hoisted_9 = /*#__PURE__*/_createVNode("span", { class: "school-ai-step-number" }, "1", -1)
const _hoisted_10 = { class: "school-ai-step-body" }
const _hoisted_11 = /*#__PURE__*/_createVNode("h2", null, [
  /*#__PURE__*/_createTextVNode(" ログインページを "),
  /*#__PURE__*/_createVNode("ruby", null, [
    /*#__PURE__*/_createTextVNode(" 開"),
    /*#__PURE__*/_createVNode("rt", null, "ひら")
  ]),
  /*#__PURE__*/_createTextVNode(" きます ")
], -1)
const _hoisted_12 = { class: "school-ai-login-access" }
const _hoisted_13 = { class: "school-ai-login-access-copy" }
const _hoisted_14 = /*#__PURE__*/_createVNode("strong", null, "ログインページQRコード", -1)
const _hoisted_15 = { class: "school-ai-service-qr-row" }
const _hoisted_16 = /*#__PURE__*/_createVNode("span", { class: "school-ai-triangle" }, "◀", -1)
const _hoisted_17 = { class: "school-ai-login-instruction" }
const _hoisted_18 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" まずはこちらを "),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createVNode("ruby", null, [
    /*#__PURE__*/_createTextVNode(" 読"),
    /*#__PURE__*/_createVNode("rt", null, "よ")
  ]),
  /*#__PURE__*/_createTextVNode(" み "),
  /*#__PURE__*/_createVNode("ruby", null, [
    /*#__PURE__*/_createTextVNode(" 取"),
    /*#__PURE__*/_createVNode("rt", null, "と")
  ]),
  /*#__PURE__*/_createTextVNode(" ってください。 ")
], -1)
const _hoisted_19 = /*#__PURE__*/_createVNode("p", { class: "school-ai-qr-note" }, [
  /*#__PURE__*/_createTextVNode(" ※Bで "),
  /*#__PURE__*/_createVNode("ruby", null, [
    /*#__PURE__*/_createTextVNode(" 使"),
    /*#__PURE__*/_createVNode("rt", null, "つか")
  ]),
  /*#__PURE__*/_createTextVNode(" うQRコードとは "),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createVNode("ruby", null, [
    /*#__PURE__*/_createTextVNode(" 別"),
    /*#__PURE__*/_createVNode("rt", null, "べつ")
  ]),
  /*#__PURE__*/_createTextVNode(" のものです。 ")
], -1)
const _hoisted_20 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  alt: "",
  "aria-hidden": "true",
  class: "school-ai-mascot"
}, null, -1)
const _hoisted_21 = { class: "school-ai-step school-ai-step-two" }
const _hoisted_22 = /*#__PURE__*/_createVNode("span", { class: "school-ai-step-number" }, "2", -1)
const _hoisted_23 = { class: "school-ai-step-two-heading" }
const _hoisted_24 = /*#__PURE__*/_createStaticVNode("<h2 data-v-4cbbb59c><ruby data-v-4cbbb59c> 先生<rt data-v-4cbbb59c>せんせい</rt></ruby> から <ruby data-v-4cbbb59c> 案内<rt data-v-4cbbb59c>あんない</rt></ruby> された <ruby data-v-4cbbb59c> 方法<rt data-v-4cbbb59c>ほうほう</rt></ruby><br data-v-4cbbb59c>を <ruby data-v-4cbbb59c> 選<rt data-v-4cbbb59c>えら</rt></ruby> びます </h2>", 1)
const _hoisted_25 = { class: "school-ai-login-info" }
const _hoisted_26 = /*#__PURE__*/_createVNode("span", null, "Aで使用するログイン情報", -1)
const _hoisted_27 = { class: "school-ai-login-info-row" }
const _hoisted_28 = /*#__PURE__*/_createVNode("strong", null, "スクールID", -1)
const _hoisted_29 = { class: "school-ai-login-info-row" }
const _hoisted_30 = /*#__PURE__*/_createVNode("strong", null, "生徒ログインID", -1)
const _hoisted_31 = { class: "school-ai-login-info-row" }
const _hoisted_32 = /*#__PURE__*/_createVNode("strong", null, "パスワード", -1)
const _hoisted_33 = { class: "school-ai-method-grid" }
const _hoisted_34 = /*#__PURE__*/_createVNode("section", { class: "school-ai-method school-ai-method-A" }, [
  /*#__PURE__*/_createVNode("h3", null, [
    /*#__PURE__*/_createVNode("span", null, "A"),
    /*#__PURE__*/_createTextVNode("ログイン情報を使う")
  ]),
  /*#__PURE__*/_createVNode("p", { class: "school-ai-instruction" }, [
    /*#__PURE__*/_createVNode("span", null, "1"),
    /*#__PURE__*/_createVNode("span", null, [
      /*#__PURE__*/_createTextVNode(" ログイン "),
      /*#__PURE__*/_createVNode("ruby", null, [
        /*#__PURE__*/_createTextVNode(" 情報"),
        /*#__PURE__*/_createVNode("rt", null, "じょうほう")
      ]),
      /*#__PURE__*/_createTextVNode(" を "),
      /*#__PURE__*/_createVNode("ruby", null, [
        /*#__PURE__*/_createTextVNode(" 入力"),
        /*#__PURE__*/_createVNode("rt", null, "にゅうりょく")
      ]),
      /*#__PURE__*/_createTextVNode(" する ")
    ])
  ]),
  /*#__PURE__*/_createVNode("img", {
    src: _imports_2,
    alt: "ログイン情報の入力箇所と生徒ログインIDでログインボタン",
    class: "school-ai-method-a-image"
  }),
  /*#__PURE__*/_createVNode("p", { class: "school-ai-instruction" }, [
    /*#__PURE__*/_createVNode("span", null, "2"),
    /*#__PURE__*/_createVNode("span", null, [
      /*#__PURE__*/_createTextVNode(" 「 "),
      /*#__PURE__*/_createVNode("ruby", null, [
        /*#__PURE__*/_createTextVNode(" 生徒"),
        /*#__PURE__*/_createVNode("rt", null, "せいと")
      ]),
      /*#__PURE__*/_createTextVNode(" ログインIDで "),
      /*#__PURE__*/_createVNode("br"),
      /*#__PURE__*/_createTextVNode(" ログイン」をタップする ")
    ])
  ])
], -1)
const _hoisted_35 = { class: "school-ai-method school-ai-method-B" }
const _hoisted_36 = /*#__PURE__*/_createVNode("h3", null, [
  /*#__PURE__*/_createVNode("span", null, "B"),
  /*#__PURE__*/_createTextVNode("QRコードを使う")
], -1)
const _hoisted_37 = /*#__PURE__*/_createVNode("p", { class: "school-ai-instruction" }, [
  /*#__PURE__*/_createVNode("span", null, "1"),
  /*#__PURE__*/_createVNode("span", { class: "school-ai-instruction-lines" }, [
    /*#__PURE__*/_createVNode("span", null, "「QRコードでログイン」"),
    /*#__PURE__*/_createVNode("span", null, "をタップ")
  ])
], -1)
const _hoisted_38 = /*#__PURE__*/_createVNode("img", {
  src: _imports_3,
  alt: "QRコードでログインボタン",
  class: "school-ai-method-b-image"
}, null, -1)
const _hoisted_39 = /*#__PURE__*/_createVNode("p", { class: "school-ai-instruction" }, [
  /*#__PURE__*/_createVNode("span", null, "2"),
  /*#__PURE__*/_createVNode("span", null, [
    /*#__PURE__*/_createTextVNode(" カメラが "),
    /*#__PURE__*/_createVNode("ruby", null, [
      /*#__PURE__*/_createTextVNode(" 起動"),
      /*#__PURE__*/_createVNode("rt", null, "きどう")
    ]),
    /*#__PURE__*/_createTextVNode(" したら "),
    /*#__PURE__*/_createVNode("br"),
    /*#__PURE__*/_createVNode("ruby", null, [
      /*#__PURE__*/_createTextVNode(" 下"),
      /*#__PURE__*/_createVNode("rt", null, "した")
    ]),
    /*#__PURE__*/_createTextVNode(" のQRコードを "),
    /*#__PURE__*/_createVNode("ruby", null, [
      /*#__PURE__*/_createTextVNode(" 読"),
      /*#__PURE__*/_createVNode("rt", null, "よ")
    ]),
    /*#__PURE__*/_createTextVNode(" み "),
    /*#__PURE__*/_createVNode("ruby", null, [
      /*#__PURE__*/_createTextVNode(" 取"),
      /*#__PURE__*/_createVNode("rt", null, "と")
    ]),
    /*#__PURE__*/_createTextVNode(" る ")
  ])
], -1)
const _hoisted_40 = /*#__PURE__*/_createVNode("small", null, "※あなたのログイン情報の入ったQRコードです", -1)
const _hoisted_41 = /*#__PURE__*/_createVNode("section", { class: "school-ai-method school-ai-method-C" }, [
  /*#__PURE__*/_createVNode("h3", null, [
    /*#__PURE__*/_createVNode("span", null, "C"),
    /*#__PURE__*/_createTextVNode("Google・Microsoft")
  ]),
  /*#__PURE__*/_createVNode("p", { class: "school-ai-instruction" }, [
    /*#__PURE__*/_createVNode("span", null, "1"),
    /*#__PURE__*/_createVNode("span", null, [
      /*#__PURE__*/_createTextVNode(" GoogleまたはMicrosoft "),
      /*#__PURE__*/_createVNode("br"),
      /*#__PURE__*/_createTextVNode(" でログインをタップ ")
    ])
  ]),
  /*#__PURE__*/_createVNode("img", {
    src: _imports_4,
    alt: "GoogleまたはMicrosoftでログインするボタン",
    class: "school-ai-method-c-image"
  }),
  /*#__PURE__*/_createVNode("p", { class: "school-ai-instruction" }, [
    /*#__PURE__*/_createVNode("span", null, "2"),
    /*#__PURE__*/_createVNode("span", null, [
      /*#__PURE__*/_createTextVNode(" Google・Microsoft "),
      /*#__PURE__*/_createVNode("br"),
      /*#__PURE__*/_createTextVNode(" のアカウント "),
      /*#__PURE__*/_createVNode("ruby", null, [
        /*#__PURE__*/_createTextVNode(" 画面"),
        /*#__PURE__*/_createVNode("rt", null, "がめん")
      ]),
      /*#__PURE__*/_createTextVNode(" で "),
      /*#__PURE__*/_createVNode("br"),
      /*#__PURE__*/_createTextVNode(" アカウントを "),
      /*#__PURE__*/_createVNode("ruby", null, [
        /*#__PURE__*/_createTextVNode(" 選択"),
        /*#__PURE__*/_createVNode("rt", null, "せんたく")
      ]),
      /*#__PURE__*/_createTextVNode(" する ")
    ])
  ]),
  /*#__PURE__*/_createVNode("small", null, [
    /*#__PURE__*/_createTextVNode(" ※Microsoftアカウントでのログイン "),
    /*#__PURE__*/_createVNode("ruby", null, [
      /*#__PURE__*/_createTextVNode(" 時"),
      /*#__PURE__*/_createVNode("rt", null, "じ")
    ]),
    /*#__PURE__*/_createTextVNode(" 、 "),
    /*#__PURE__*/_createVNode("br"),
    /*#__PURE__*/_createTextVNode("「 "),
    /*#__PURE__*/_createVNode("ruby", null, [
      /*#__PURE__*/_createTextVNode(" 同意"),
      /*#__PURE__*/_createVNode("rt", null, "どうい")
    ]),
    /*#__PURE__*/_createTextVNode(" 」ボタンを "),
    /*#__PURE__*/_createVNode("ruby", null, [
      /*#__PURE__*/_createTextVNode(" 選択"),
      /*#__PURE__*/_createVNode("rt", null, "せんたく")
    ])
  ])
], -1)
const _hoisted_42 = { class: "school-ai-sheet-footer" }
const _hoisted_43 = { class: "school-ai-guide-title" }
const _hoisted_44 = /*#__PURE__*/_createVNode("img", {
  src: _imports_5,
  class: "school-ai-book-icon",
  alt: "",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_45 = /*#__PURE__*/_createVNode("strong", null, [
  /*#__PURE__*/_createVNode("ruby", null, [
    /*#__PURE__*/_createTextVNode(" 公式"),
    /*#__PURE__*/_createVNode("rt", null, "こうしき")
  ]),
  /*#__PURE__*/_createTextVNode(" ガイド ")
], -1)
const _hoisted_46 = /*#__PURE__*/_createVNode("img", {
  src: _imports_6,
  alt: "スクールAI公式ガイドのQRコード",
  class: "school-ai-manual-qr"
}, null, -1)
const _hoisted_47 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" ※この "),
  /*#__PURE__*/_createVNode("ruby", null, [
    /*#__PURE__*/_createTextVNode(" 用紙"),
    /*#__PURE__*/_createVNode("rt", null, "ようし")
  ]),
  /*#__PURE__*/_createTextVNode(" は "),
  /*#__PURE__*/_createVNode("ruby", null, [
    /*#__PURE__*/_createTextVNode(" 大切"),
    /*#__PURE__*/_createVNode("rt", null, "たいせつ")
  ]),
  /*#__PURE__*/_createTextVNode(" に "),
  /*#__PURE__*/_createVNode("ruby", null, [
    /*#__PURE__*/_createTextVNode(" 保管"),
    /*#__PURE__*/_createVNode("rt", null, "ほかん")
  ]),
  /*#__PURE__*/_createTextVNode(" しておきましょう "),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode(" ※ログインができない "),
  /*#__PURE__*/_createVNode("ruby", null, [
    /*#__PURE__*/_createTextVNode(" 場合"),
    /*#__PURE__*/_createVNode("rt", null, "ばあい")
  ]),
  /*#__PURE__*/_createTextVNode(" は "),
  /*#__PURE__*/_createVNode("ruby", null, [
    /*#__PURE__*/_createTextVNode(" 先生"),
    /*#__PURE__*/_createVNode("rt", null, "せんせい")
  ]),
  /*#__PURE__*/_createTextVNode(" に "),
  /*#__PURE__*/_createVNode("ruby", null, [
    /*#__PURE__*/_createTextVNode(" 相談"),
    /*#__PURE__*/_createVNode("rt", null, "そうだん")
  ]),
  /*#__PURE__*/_createTextVNode(" してください ")
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_MPrintInvitaion = _resolveComponent("MPrintInvitaion")
  const _component_qrcode_vue = _resolveComponent("qrcode-vue")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_MPrintInvitaion, {
      "clipboard-status-type": _ctx.clipboardStatusType,
      "clipboard-message": _ctx.clipboardMessage,
      "is-start-learning-btn-shown": false,
      onPrint: _ctx.print,
      onMessageCopy: _ctx.messageCopy
    }, null, 8, ["clipboard-status-type", "clipboard-message", "onPrint", "onMessageCopy"]),
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.datas, (data) => {
          return (_openBlock(), _createBlock("article", {
            key: data.key,
            class: "school-ai-sheet"
          }, [
            _createVNode("header", _hoisted_3, [
              _createVNode("div", _hoisted_4, [
                (_ctx.isSucceedLoginData(data))
                  ? (_openBlock(), _createBlock("div", _hoisted_5, _toDisplayString(_ctx.serviceNameOf(data)), 1))
                  : (_openBlock(), _createBlock("img", _hoisted_6))
              ]),
              _hoisted_7,
              _createVNode("div", {
                ref: "studentNameContainers",
                class: "school-ai-student-name",
                title: `${data.studentName}さん`
              }, [
                _createVNode("span", null, _toDisplayString(data.studentName) + "さん", 1)
              ], 8, ["title"])
            ]),
            _createVNode("section", _hoisted_8, [
              _hoisted_9,
              _createVNode("div", _hoisted_10, [
                _hoisted_11,
                _createVNode("div", _hoisted_12, [
                  _createVNode("div", _hoisted_13, [
                    _hoisted_14,
                    _createVNode("div", _hoisted_15, [
                      _createVNode(_component_qrcode_vue, {
                        class: "school-ai-service-qr",
                        value: _ctx.SCHOOL_AI_LOGIN_URL,
                        size: 180,
                        level: "H"
                      }, null, 8, ["value"]),
                      _hoisted_16,
                      _createVNode("div", _hoisted_17, [
                        _hoisted_18,
                        _createVNode("a", {
                          href: _ctx.SCHOOL_AI_LOGIN_URL,
                          target: "_blank"
                        }, _toDisplayString(_ctx.SCHOOL_AI_LOGIN_URL), 9, ["href"])
                      ])
                    ])
                  ]),
                  _hoisted_19
                ])
              ]),
              _hoisted_20
            ]),
            _createVNode("section", _hoisted_21, [
              _hoisted_22,
              _createVNode("div", _hoisted_23, [
                _hoisted_24,
                _createVNode("div", _hoisted_25, [
                  _hoisted_26,
                  _createVNode("div", _hoisted_27, [
                    _hoisted_28,
                    _createVNode("span", null, _toDisplayString(data.schoolId), 1)
                  ]),
                  _createVNode("div", _hoisted_29, [
                    _hoisted_30,
                    _createVNode("span", null, _toDisplayString(data.loginId), 1)
                  ]),
                  _createVNode("div", _hoisted_31, [
                    _hoisted_32,
                    _createVNode("span", null, _toDisplayString(data.password), 1)
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_33, [
                _hoisted_34,
                _createVNode("section", _hoisted_35, [
                  _hoisted_36,
                  _hoisted_37,
                  _hoisted_38,
                  _hoisted_39,
                  _createVNode(_component_qrcode_vue, {
                    class: "school-ai-personal-qr",
                    value: data.code,
                    size: 220,
                    level: "H"
                  }, null, 8, ["value"]),
                  _hoisted_40
                ]),
                _hoisted_41
              ])
            ]),
            _createVNode("footer", _hoisted_42, [
              _createVNode("div", _hoisted_43, [
                _hoisted_44,
                _hoisted_45,
                _createVNode("a", {
                  href: _ctx.SCHOOL_AI_PRINT_GUIDE_URL,
                  target: "_blank"
                }, _toDisplayString(_ctx.SCHOOL_AI_PRINT_GUIDE_URL), 9, ["href"])
              ]),
              _hoisted_46,
              _hoisted_47
            ])
          ]))
        }), 128))
      ])
    ])
  ], 64))
})